export default __webpack_public_path__ + "static/media/White0002.6e5a32ff.png";